import React from 'react';
import Logo from 'assets/img/spinner.png';

const LogoSpinner = () => <img className="logo-spinner" alt="Logo" src={Logo} />;

export default LogoSpinner;
